/**
 * Plural por contagem — "1 grupo", "2 grupos", "1 que sumiu", "3 que sumiram".
 *
 * Existe porque a tela dizia "3 pessoa(s)" e "7 respondida(s)", e o owner mandou tirar todo "(s)"
 * (05/09). O número sai em pt-BR (`1.234`), que é o formato de todo número do produto.
 */
export function contar(n: number, um: string, varios: string): string {
  return `${n.toLocaleString("pt-BR")} ${n === 1 ? um : varios}`;
}
